module.exports = __webpack_public_path__ + "img/9m.c440b065.png";